import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { CloseIcon } from 'assets/icons'
import { initiativeUrl } from 'config/constants/urls'
import InitiativeList from 'src/apps/Initiative/components/List'
import InitiativeListItemRow from 'src/apps/Initiative/components/ListItemRow'
import DiscussionListItemRow from 'src/apps/Discussions/components/ListItemRow'
import { arrayToSentenceFragment } from 'src/components/utils'
import { useOrganization } from 'src/graphql/hooks'

const ProfileCollection = ({ onCloseButtonClick }) => {
   const { collectionFilter, userId } = useParams()
   const { organization } = useOrganization()

   let title
   let ListItemRow = InitiativeListItemRow
   const initiativeListFilter = {
      limit: 20,
      sortBy: 'dateLastUpdated',
      userRelationshipFilter: {
         userId,
         hasElementType: 'roleParticipant'
      }
   }

   if (collectionFilter === 'following') {
      title = 'Following'
      ListItemRow = DiscussionListItemRow

      // TODO: Improve this
      // For now, when looking at "Following" initiatives, we only want to show discussions
      // as they are effectively the only thing you as a user deliberately follow now
      // (You may also follow other initiatives indirectly when you comment on them,
      // but it currently feels wierd to show them here UX-wise). Right now, discussions are
      // the only thing UI-wise where you actually SEE a "Follow" button.
      // See PR #458
      const discussionInitiativeTypes = organization.initiativeTypes
         .filter(t => t.enabled && t.class === 'discussion')

      const discussionInitiativeTypeIds = discussionInitiativeTypes.map(t => t.id)
      initiativeListFilter.typeIds = discussionInitiativeTypeIds
      initiativeListFilter.userRelationshipFilter.hasElementType = 'subscribed'
   } else if (collectionFilter === 'drafts') {
      title = 'Drafts'
      initiativeListFilter.drafts = 'only'
   } else {
      if (collectionFilter === 'discussion') {
         ListItemRow = DiscussionListItemRow
      }

      const initiativeTypes = organization.initiativeTypes
         .filter(t => t.enabled && t.class === collectionFilter)

      const initiativeTypeIds = initiativeTypes.map(t => t.id)
      const initiativeTypeNames = initiativeTypes.map(t => t.namePlural)
      title = arrayToSentenceFragment(initiativeTypeNames)

      initiativeListFilter.archived = 'include'
      initiativeListFilter.typeIds = initiativeTypeIds
   }

   return (
      <View
         position="relative"
         float="left"
         width="100%"
         height="100%"
         scroll="on">
         <View
            position="absolute"
            right="0px"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            height="60px"
            padding="0px 18px"
            zIndex="2">
            <View
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               onClick={onCloseButtonClick}>
               <CloseIcon width="24px" height="24px" />
            </View>
         </View>
         <View
            float="left"
            width="100%"
            padding="20px"
            borderBottom="1px solid #eee">
            <Text color="#000" size="5" weight="medium">
               {title}
            </Text>
         </View>
         <View
            float="left"
            width="100%"
            padding="5px 10px">
            <InitiativeList filter={initiativeListFilter}>
               {initiativeList => initiativeList.items.map((initiative, index) => (
                  <ListItemRow
                     key={initiative.id}
                     addedBy={initiative.addedBy.fullName}
                     archived={initiative.archived}
                     coverUrl={initiative.coverMedia?.file.thumbnailUrlW480}
                     dateLastUpdated={initiative.dateLastUpdated}
                     discussionFormat={initiative.discussionFormat}
                     discussionIsClosed={initiative.discussionStatus?.closed}
                     hasUnreadEntries={initiative.thread.hasUnreadEntries}
                     linkTo={initiativeUrl(initiative)}
                     name={initiative.name}
                     numThreadEntries={initiative.thread.numEntries}
                     numViews={initiative.numViews}
                     pinned={initiative.pinned}
                     privacy={initiative.privacy}
                     slug={initiative.slug}
                     typeSlug={initiative.type.slug}
                     borderStyle={index === 0 ? 'none' : '1px solid #eee'}
                  />
               ))}
            </InitiativeList>
         </View>
      </View>
   )
}

ProfileCollection.propTypes = {
   onCloseButtonClick: PropTypes.func.isRequired
}

export default ProfileCollection
